import React, { useState, memo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Popover } from 'antd'
import './index.scss'
import NoSSR from '@/components/rc-no-ssr'
import BasicSlider from './modules/slider'
import BasicService from './modules/service'
import { UseIntentOrder } from '../intent-modal/order'
import { UseIntentBargain } from '../intent-modal/bargain'
import { UseIntentDiscountNotify } from '../intent-modal/discount-notify'

import iconYanxuan from '~/img/buy/yanxuan-icon.png'

const DetailBasic = ({ basic, servicePriceConfig }) => {
  const basicInfo = basic.basic_info
  const { sold } = basicInfo
  const { city } = useSelector(store => store)
  const { fr, ino } = city
  const { phone } = useSelector(store => store.user)
  const sellOnConsignment = basicInfo.sell_on_consignment
  // 车价
  const newcarPrice = Number(basicInfo.price).toFixed(
    basicInfo.price > 100 ? 0 : 2
  )
  const { tax, price } = basic.basic_info
  const showPrice = (Number(basicInfo.newcar_price) + Number(tax)).toFixed(2)
  // 同款车
  const simailarLink = `https://www.renrenche.com/${city.city}/${basicInfo?.b_pinyin}${basicInfo?.s_pinyin ? `_${basicInfo?.s_pinyin}` : ''}`

  // 价格tip
  const priceTip = (
    <div className="r-price-tip">
      <p className="price">厂商新车指导价：{basicInfo.newcar_price}万</p>
      <p className="tax">车辆购置税：{tax}万</p>
      <p className="msg">
        &quot;新车指导价&quot;是厂商公布的指导价，不是零售价，亦不是该车购入价。
      </p>
    </div>
  )

  // 外迁tip
  const outerTip = (
    <div className="r-outer-tip">
      排放标准以各地车管所实际认定为准，外迁标准以迁入地车管所规定为准。
    </div>
  )

  // 过户次数tip
  const transferTip = (
    <div className="r-outer-tip">该信息应以车辆登记证书登记为准。</div>
  )

  // 服务费
  const services = servicePriceConfig?.termInfo?.services?.slice(0, 6) || []
  const servicesDesc = servicePriceConfig?.termInfo?.service_desc
  const { tags } = basic
  const chargeInfo = servicePriceConfig?.chargeInfo
  const claimLimit = servicePriceConfig?.termInfo?.claimInfo?.claim_limit

  // 降价提醒
  const showDiscountNotify = () => {
    global.$rbl.push({
      event: 'car-detail_basicinformation-priceremind_click',
      content: { param: '咨询-PC-详情页-2' }
    })
    const submitParams = {
      mobile_number: phone || '',
      phone_source: `${fr}${ino ? '_异地' : ''}_降价通知`,
      owner_price: `${price}`,
      submit_sources: '咨询-PC-详情页-2'
    }
    const otherParams = { basicInfo }
    new UseIntentDiscountNotify({ submitParams, otherParams }).open()
  }
  // 预约看车
  const toOrder = () => {
    global.$rbl.push({
      event: 'car-detail_basicinformation-appointment_click',
      content: {
        param: '预约看车-PC-详情页-1'
      }
    })
    const submitParams = {
      mobile_number: phone || '',
      phone_source: `${fr}${ino ? '_异地' : ''}`,
      sub_product: '预约看车',
      submit_sources: '预约看车-PC-详情页-1'
    }
    const otherParams = { ino, basicInfo }
    new UseIntentOrder({
      intentType: 'order',
      submitParams,
      otherParams
    }).open()
  }

  // 砍价
  const toBargain = () => {
    global.$rbl.push({
      event: 'car-detail_basicinformation-cutprice_click',
      content: {
        param: '砍价-PC-详情页-1'
      }
    })
    const submitParams = {
      phone: phone || '',
      owner_price: `${price}`,
      source: `${fr}${ino ? '_异地' : ''}`,
      submit_sources: '砍价-PC-详情页-1'
    }
    const otherParams = { basicInfo }
    new UseIntentBargain({ submitParams, otherParams }).open()
  }

  // 服务项详情
  const [showServiceDetail, setServiceDetailView] = useState(false)
  const middleSuffix = '?imageView/4/w/720/h/480'
  return (
    <>
      <div className="r-basic">
        <div className="r-basic__pic">
          {sold === true ? (
            <div className="r-basic__pic-sold">
              <img
                src={basic.images[0].img_url + middleSuffix}
                alt="车源详情"
              />
              <div className="recommend clearfix">
                <div className="car-id">车源号：{basicInfo.rrc_id}</div>
              </div>
              <div className="tip">已下架</div>
            </div>
          ) : (
            <BasicSlider basic={basic} carId={basic.carId} />
          )}
        </div>
        <div className="r-basic__info">
          <h1 className="title">
            {sellOnConsignment === 1 ? (
              <img src={iconYanxuan} alt="严选车" />
            ) : (
              <></>
            )}
            <NoSSR>{basicInfo.title}</NoSSR>
          </h1>
          <ul className="tags clearfix">
            {/* 最多显示10个标签 */}
            {tags && tags.slice(0, 10).map(tag => (
              <li
                className="tag"
                key={tag.txt}
                style={{ backgroundColor: tag.color }}
              >
                {tag.txt}
              </li>
            ))}
          </ul>

          {/* 价格框部分 */}
          <div className="price">
            <p className="carprice clearfix">
              <span className="newcar-price">
                <span className="num"><NoSSR>{newcarPrice}</NoSSR></span>万
              </span>
              <span
                className="newcar-price-tax"
                onMouseEnter={() => { global.$rbl.push({ event: 'car-detail_basicinformation-taxinclusivepricenote_hover', content: { expand: { timeStamp: new Date() } } }) }}
              >
                新车含税<span className="num-tax"><NoSSR>{showPrice}</NoSSR></span>万
                <Popover content={priceTip} title={null} placement="bottom">
                  <i className="iconfont icon-tip-icon2-07d8d303" />
                </Popover>
              </span>
              {!sold && (
                <span className="cut-tip" onClick={showDiscountNotify}>
                  降价提醒
                </span>
              )}
            </p>
            <p className="servicefee clearfix">
              <span>服务费</span>
              <span className="fee">{`${chargeInfo?.service_price || '计算中···'}${chargeInfo?.service_price_desc || ''}`}</span>
              <span
                className="detail"
                data-click="car-detail_basicinformation-servicedetail_click"
                onClick={() => {
                  setServiceDetailView(true)
                }}
              >
                查看详情&nbsp;&gt;
              </span>
            </p>
            <ul className="service clearfix">
              {services.map(service => (
                <li key={service.text} className="service-item">
                  <i className="iconfont icon-hehuoren_v8_2" />
                  {service.text}
                </li>
              ))}
            </ul>
          </div>

          {/* 参数部分 */}
          <ul className="parameters">
            <li className="parameter">
              <p className="value">
                {Number(basicInfo.mileage).toFixed(2)}万公里
              </p>
              <p className="name">表显里程</p>
            </li>
            <li className="parameter">
              <p className="value">{basicInfo.format_licensed_diff}</p>
              <p className="name">上牌</p>
            </li>
            <li className="parameter">
              <p className="value">{basicInfo.licensed_city}</p>
              <p className="name">车辆所在地</p>
            </li>
            <li
              className="parameter"
              onMouseEnter={() => { global.$rbl.push({ event: 'car-detail_basicinformation-configuration-emissionnote_hover', content: { expand: { timeStamp: new Date() } } }) }}
            >
              <p className="value">
                {basicInfo.emission}
                <Popover content={outerTip} title={null} placement="top">
                  <i className="iconfont icon-tip-icon2-07d8d303" />
                </Popover>
              </p>

              <p className="name">
                <a
                  className="qian"
                  target="_blank"
                  rel="noopener noreferrer"
                  click="basicinformation-qian_click"
                  href="https://qian.renrenche.com/"
                >
                  外迁查询
                </a>
              </p>
            </li>
            <li className="parameter">
              <p className="value">
                {basicInfo.transmission === 'MT' ? '手动' : '自动'}
              </p>
              <p className="name">变速箱</p>
            </li>
            <li
              className="parameter"
              data-hover="car-detail_basicinformation-configuration-transfernote_hover"
            >
              <p className="value">
                {basicInfo.transfer_records.length}次
                <Popover content={transferTip} title={null} placement="top">
                  <i className="iconfont icon-tip-icon2-07d8d303" />
                </Popover>
              </p>
              <p className="name"> 过户记录</p>
            </li>

            {basicInfo.publish_time_desc && (
              <li className="parameter">
                <p className="value">{basicInfo.publish_time_desc}</p>
                <p className="name">上架时间</p>
              </li>
            )}
          </ul>

          {/* 看车、砍价 按钮组 */}
          {!sold && (
            <div className="actions">
              <a className="item order" onClick={toOrder}>
                预约看车
              </a>
              <a className="item bargain" onClick={toBargain}>
                砍价
              </a>
              {/* <div className="tel">
                <p>电话咨询</p>
                <p>{city?.phone_source?.buyer}</p>
              </div> */}
            </div>
          )}
          {sold && (
            <div className="actions">
              <a className="item order sold">已下架</a>
              <a
                className="item bargain"
                href={simailarLink}
              >
                找同款车
              </a>
              {/* <div className="tel">
                <p>电话咨询</p>
                <p>{city?.phone_source?.buyer}</p>
              </div> */}
            </div>
          )}
        </div>
      </div>

      {/* 查看详情->人人车服务介绍弹框 */}
      <BasicService
        visible={showServiceDetail}
        onClose={() => setServiceDetailView(false)}
        params={{ servicesDesc, claimLimit }}
      />
    </>
  )
}

export default memo(DetailBasic)

DetailBasic.propTypes = {
  basic: PropTypes.object,
  servicePriceConfig: PropTypes.object
}

DetailBasic.defaultProps = {
  basic: {},
  servicePriceConfig: {}
}
